<div (dragover)="startUploadFiles()">
  <div class="filebrowser-loading-screen-overlay" *ngIf="isDownloading">
    <div><app-loading-dots size="5px"></app-loading-dots></div>
  </div>

  <div class="file-browser-toolbar">
    <div>
      <p-inputgroup>
        <input
          pInputText
          [(ngModel)]="searchParam"
          [placeholder]="'search_files' | translation"
          (keydown.enter)="search(searchParam)"
          fluid />
        <p-inputgroup-addon>
          <p-button
            severity="contrast"
            variant="text"
            (click)="search(searchParam)">
            <i class="fa-thin fa-magnifying-glass"></i>
          </p-button>
        </p-inputgroup-addon>
      </p-inputgroup>
    </div>
    <div>
      <p-selectbutton
        optionValue="value"
        [(ngModel)]="displayType"
        severity="info"
        [allowEmpty]="false"
        [options]="[
          { icon: 'fas fa-th', value: 'tiles' },
          { icon: 'fas fa-bars', value: 'list' },
        ]"
        (onChange)="displayChange($event)">
        <ng-template #item let-item>
          <i [class]="item.icon"></i>
        </ng-template>
      </p-selectbutton>
    </div>
    <div style="display: flex">
      <label class="app-label app-label-table"
        >{{ 'filter_by' | translation }}:</label
      >
      <p-select
        [options]="typeFilterOptions"
        placeholder="{{ 'filter_type' | translation }}"
        [(ngModel)]="typeFilter"
        [disabled]="filter"
        (onChange)="navigate(null, folder, true, true, false)"
        optionLabel="label"
        optionValue="value"></p-select>
    </div>

    <div style="display: flex">
      <label class="app-label app-label-table"
        >{{ 'paginate_items_per_page' | translation }}:</label
      >
      <p-select
        [options]="perPageOptions"
        placeholder="Per Page"
        [(ngModel)]="perPage"
        (onChange)="setPageCount($event)"
        optionLabel="count"
        optionValue="count"></p-select>
    </div>
    <div style="flex: 1 1 auto"></div>
    <div *ngIf="allowupload && !isDisable()" style="display: flex; gap: 10px">
      <button pButton (click)="startUploadFiles()">
        {{ 'upload_files' | translation }}
      </button>
      <button pButton (click)="startCreateFolder()">
        {{ 'new_folder' | translation }}
      </button>
    </div>
  </div>
  <div *ngIf="terms.length">
    <p>{{ 'searching' | translation }}:</p>
    <div
      *ngFor="let term of terms; let i = index"
      style="display: inline-block; margin-right: 5px">
      <p-chip
        label="{{ term }}"
        [removable]="true"
        (onRemove)="removeTerm(i)"></p-chip>
    </div>
  </div>
  <div>
    <h2>{{ 'folders' | translation }}</h2>
  </div>
  <div class="file-folder-breadcrumbs" aria-label="file browser breadcrumbs">
    <span>
      <ng-container *ngIf="folder.get('route')?.length !== 0; else textview">
        <a (click)="navigate($event, basefolder)" href="#">
          {{
            scope === 'institution'
              ? ('global' | translation)
              : ('course' | translation)
          }}
        </a>
      </ng-container>
      <ng-template #textview>
        <span class="color-style-grey">
          {{
            scope === 'institution'
              ? ('global' | translation)
              : ('course' | translation)
          }}
        </span>
      </ng-template>
    </span>
    <span *ngFor="let fold of folder.get('route'); let i = index">
      <i
        class="fas fa-chevron-right"
        style="font-size: 10px; margin-right: 5px"></i>

      <ng-container
        *ngIf="i !== folder.get('route')?.length - 1; else textview">
        <a (click)="navigate($event, fold)" href="#">
          {{ fold.data.title }}
        </a>
      </ng-container>
      <ng-template #textview>
        <span class="color-style-grey">{{ fold.data.title }}</span>
      </ng-template>

      <!-- <a (click)="navigate($event, fold)" href="#">
        {{ fold.data.title }} </a
      > -->
    </span>
  </div>
  <div class="file-browser-content">
    <div *ngIf="creatingFolder && !readOnly">
      <p-inputgroup>
        <input
          pInputText
          placeholder="Folder Name"
          [(ngModel)]="newFolderName" />
        <p-inputgroup-addon>
          <p-button
            severity="contrast"
            variant="text"
            (click)="createFolder(newFolderName)"
            [disabled]="!newFolderName || newFolderName.length === 0">
            <i class="fas fa-check"></i>
          </p-button>
        </p-inputgroup-addon>

        <p-inputgroup-addon>
          <p-button
            severity="secondary"
            variant="text"
            (click)="cancelFolder()">
            <i class="fas fa-ban"></i>
          </p-button>
        </p-inputgroup-addon>
      </p-inputgroup>
    </div>

    <div
      class="file-browser-main"
      [ngClass]="{ 'file-list': !tiles, 'file-tiles': tiles }">
      <div *ngIf="isLoadingFolders; else foldersView">
        <div><app-loading-dots size="5px"></app-loading-dots></div>
      </div>
      <ng-template #foldersView>
        <h6 *ngIf="!folder.get('folders')?.length; else displayFolders">
          {{ 'no_folders_to_display' | translation }}
        </h6>

        <ng-template #displayFolders>
          <app-file-display
            class="file-content-row"
            *ngFor="let item of folder.get('folders')"
            [ngClass]="{ 'filde-browser-selected': selectedFile === item }"
            (click)="navigate($event, item)"
            (keydown)="keydown($event, item)"
            role="button"
            [item]="item"
            [tiles]="tiles"
            tabindex="0"
            [isDisabled]="isDisable()"
            (settings)="openSettings($event)"
            (move)="openMove($event)"
            (delete)="delete($event)"
            (zip)="startZipFolder($event)">
          </app-file-display>
        </ng-template>
      </ng-template>
    </div>
  </div>
  <scaffold-paginator
    *ngIf="
      (totalFolderItems && perPage < totalFolderItems) ||
      totalFolderItems === null
    "
    (activePageChange)="activePageChange($event, 'folder')"
    [itemCount]="totalFolderItems"
    [(activePage)]="currentFolderPage"
    [perPage]="perPage"></scaffold-paginator>

  <div>
    <h2>
      {{ 'files' | translation }} <span *ngIf="filter">({{ filter }})</span>
    </h2>
  </div>

  <div class="file-browser-content">
    <div
      class="file-browser-main"
      [ngClass]="{ 'file-list': !tiles, 'file-tiles': tiles }">
      <div *ngIf="isLoadingFiles; else filesView">
        <div><app-loading-dots size="5px"></app-loading-dots></div>
      </div>
      <ng-template #filesView>
        <h6 *ngIf="!folder.get('files')?.length; else filesDisplay">
          {{ 'no_files_to_display' | translation }}
        </h6>
        <ng-template #filesDisplay>
          <app-file-display
            class="file-content-row"
            *ngFor="let item of folder.get('files'); trackBy: trackByIndex"
            [ngClass]="{
              'filde-browser-selected': selectedFile === item,
              'file-browser-allow-selection': allowSelection,
            }"
            (click)="selectFileItem(item)"
            (keydown.enter)="selectFileItem(item)"
            (keydown.space)="selectFileItem(item)"
            [item]="item"
            [tiles]="tiles"
            [tabindex]="allowSelection ? 0 : -1"
            [isDisabled]="isDisable()"
            role="button"
            (settings)="openSettings($event)"
            (zip)="startZip($event)"
            (move)="openMove($event)"
            (delete)="delete($event)">
          </app-file-display>
        </ng-template>
      </ng-template>
    </div>
  </div>
  <scaffold-paginator
    *ngIf="totalFileItems && perPage < totalFileItems"
    (activePageChange)="activePageChange($event, 'files')"
    [itemCount]="totalFileItems"
    [(activePage)]="currentFilePage"
    [perPage]="perPage"></scaffold-paginator>

  <p *ngIf="courseFileSize">
    {{ 'course_file_storage' | translation }}: {{ courseFileSize | filesize }}
  </p>
</div>
